import { render } from "./LoadingScreen.vue?vue&type=template&id=3d83cae7&scoped=true&ts=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=ts"
export * from "./LoadingScreen.vue?vue&type=script&lang=ts"

import "./LoadingScreen.vue?vue&type=style&index=0&id=3d83cae7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d83cae7"]])

export default __exports__